export default {"src":"/_next/static/media/ic-additional-brand-list.b5412793.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};